(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footnotes"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('story-blocks-page')) return;

  customElements.define(
    'story-blocks-page',
    class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.events) return;

        this.events = new AbortController();

        const on = (element, event, handler) => {
          element.addEventListener(event, handler, {
            signal: this.events.signal
          });
        };

        const reduced = matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        const loops = [
          ...this.querySelectorAll('[data-loop]')
        ];

        const dialog = this.querySelector('.st-player');
        const player = dialog.querySelector('video');
        const status = dialog.querySelector('.st-status');

        let opener;
        let resume = [];
        let oldOverflow;

        const restore = () => {
          if (oldOverflow !== undefined) {
            document.documentElement.style.overflow =
              oldOverflow;

            oldOverflow = undefined;
          }
        };

        loops.forEach(video => {
          video.muted = true;

          on(video, 'error', () => {
            video.hidden = true;
          });

          if (!reduced.matches) {
            video.src = video.dataset.src;
            video.play().catch(() => {});
          }
        });

        on(reduced, 'change', () => {
          if (reduced.matches) {
            loops.forEach(video => video.pause());
          }
        });

        this.querySelectorAll('[data-play]').forEach(button => {
          on(button, 'click', () => {
            opener = button;
            status.hidden = true;

            resume = loops.filter(video => !video.paused);
            resume.forEach(video => video.pause());

            dialog.showModal();

            oldOverflow =
              document.documentElement.style.overflow;

            document.documentElement.style.overflow =
              'hidden';

            player.src = button.dataset.play;
            player.muted = false;
            player.play().catch(() => {});
          });
        });

        on(
          dialog.querySelector('.st-close'),
          'click',
          () => dialog.close()
        );

        on(player, 'error', () => {
          status.textContent =
            'This video could not be loaded. Please try again later.';

          status.hidden = false;
        });

        on(dialog, 'close', () => {
          player.pause();
          player.removeAttribute('src');
          player.load();

          restore();

          if (!reduced.matches) {
            resume.forEach(video => {
              video.play().catch(() => {});
            });
          }

          opener?.focus();
        });

        this.cleanup = () => {
          this.events.abort();
          this.events = null;

          player.pause();
          loops.forEach(video => video.pause());

          if (dialog.open) {
            dialog.close();
          }

          restore();
        };
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.cleanup?.();
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
